module.exports = __webpack_public_path__ + "img/achievement.914107c.png";